import React from "react";
import { cn } from "./cn";

const TONES = {
  ink: "bg-bun-ink",
  blue: "bg-bun-blue",
  success: "bg-bun-success",
  danger: "bg-bun-danger",
  special: "bg-bun-special",
  warning: "bg-bun-warning",
  neutral: "bg-bun-stone",
  "data-violet": "bg-bun-data-violet",
};

/**
 * Bun progress bar: rounded track on mist-deep, blue fill (success for
 * completion contexts like welcome-flow cards). value: 0-100.
 */
export default function ProgressBar({ as: Component = "div", value = 0, tone = "blue", color, size = "md", variant = "linear", className, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy }) {
  const clamped = Math.max(0, Math.min(100, value));
  if (variant === "battery") {
    return <svg viewBox="0 0 38 20" role="progressbar" aria-label={ariaLabel} aria-labelledby={ariaLabelledBy}
      aria-valuenow={Math.round(clamped)} aria-valuemin={0} aria-valuemax={100}
      className={cn("h-5 w-[38px] shrink-0", { success: "text-bun-success", danger: "text-bun-danger", warning: "text-bun-warning", neutral: "text-bun-stone" }[tone] || "text-bun-stone", className)}>
      <rect x="1" y="2" width="31" height="16" rx="3" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <rect x="4" y="5" width={25 * clamped / 100} height="10" rx="1" fill="currentColor" />
      <path d="M35 7v6" stroke="currentColor" strokeWidth="2" />
    </svg>;
  }
  if (variant === "ring") {
    return (
      <svg viewBox="0 0 56 56" className={cn("shrink-0 -rotate-90", size === "sm" ? "h-12 w-12" : "h-14 w-14", className)}
        role="progressbar" aria-label={ariaLabel} aria-labelledby={ariaLabelledBy}
        aria-valuenow={Math.round(clamped)} aria-valuemin={0} aria-valuemax={100}>
        <circle cx="28" cy="28" r="24" fill="none" strokeWidth="5" stroke="currentColor" className="text-bun-line-soft" />
        <circle cx="28" cy="28" r="24" fill="none" strokeWidth="5" stroke="currentColor" strokeLinecap="round" pathLength="100"
          strokeDasharray={`${clamped} 100`} className="text-bun-ink" style={color ? { color } : undefined} />
      </svg>
    );
  }
  return (
    <Component
      role="progressbar"
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      aria-valuenow={Math.round(clamped)}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn(
        "w-full rounded-full bg-bun-mist-deep overflow-hidden",
        size === "sm" ? "h-[4px]" : "h-[6px]",
        className
      )}
    >
      <span
        style={{ width: `${clamped}%`, backgroundColor: color }}
        className={cn(
          "block h-full rounded-full transition-[width] duration-300",
          TONES[tone] || TONES.blue
        )}
      />
    </Component>
  );
}
